
import { useEventBusListener } from '../utils/useEventBus';
import { useInstance } from 'common-module/src/util/useInstance';
import { layoutDrawerAction } from '@/model/action';

export interface EventModel {
  showDrawer: (action: layoutDrawerAction) => void;
}

export const useLayoutListener = (events: EventModel) => {
  const LAYOUT_SHOW = 'config-field-layout:show';
  const instance = useInstance();

  // 打开布局弹窗
  useEventBusListener(instance, LAYOUT_SHOW, (action: layoutDrawerAction) => {
    console.log('show layout eventBus', events, action);
    typeof events.showDrawer === 'function' && events.showDrawer(action);
  });
};